import React, { FunctionComponent, useState, useEffect } from 'react'
import { Col, notification, Row, Space, Table, Typography } from 'antd'
import { FilterValue, SorterResult, TablePaginationConfig } from 'antd/lib/table/interface'

import { DEFAULT_PAGE_SIZE } from '../../../../constants'
import { IReview } from '../../../../context/types'

import { columns } from './columns'

import { fetchReviewsList, moderateReview } from '../../../../context/review'

const { Title } = Typography

interface ReviewsProps {
	state?: number
	forceUpdate?: () => void
}

const Reviews: FunctionComponent<ReviewsProps> = (props) => {
	const { state, forceUpdate } = props

	const [reviews, setReviews] = useState<IReview[]>([])
	const [loading, setLoading] = useState(false)

	const [page, setPage] = useState(1)
	const [column, setColumn] = useState('id')
	const [order, setOrder] = useState<Order>('descend')

	const [total, setTotal] = useState(10)

	useEffect(() => {
		setLoading(true)
		fetchReviewsList((page - 1) * DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE, column, order)
			.then((r) => {
				setReviews(r.list)
				setTotal(r.total)
			})
			.catch(handleError)
			.finally(() => setLoading(false))
	}, [page, order, column, state])

	const handleError = (err: any) => {
		notification.error({ message: err.message || 'Server error' })
	}

	const onChange: OnChange = (pagination, _, sorter) => {
		const customSorter = sorter as SorterResult<IReview>

		setOrder((customSorter.order as Order) || 'descend')
		setColumn(customSorter.columnKey as string)
		setPage(pagination.current)
	}

	const handleModerate = (id: number) => {
		setLoading(true)
		moderateReview(id)
			.then(() => forceUpdate())
			.catch(handleError)
			.finally(() => setLoading(false))
	}

	return (
		<Space direction="vertical" style={{ width: '100%' }}>
			<Row>
				<Col>
					<Title level={3}>Reviews</Title>
				</Col>
			</Row>
			<Table
				rowKey={'id'}
				columns={columns(handleModerate)}
				dataSource={reviews}
				pagination={!!reviews?.length && { pageSize: DEFAULT_PAGE_SIZE, current: page, total }}
				loading={loading}
				onChange={onChange}
			/>
		</Space>
	)
}

export default Reviews

type Order = 'ascend' | 'descend' | undefined
type OnChange = (
	pagination: TablePaginationConfig,
	filters: Record<string, FilterValue | null>,
	sorter: SorterResult<any> | SorterResult<any>[]
) => void
